import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notificationCount: 0,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationCount(state, action) {
      state.notificationCount = action.payload;
    },

    incrementNotification(state) {
      state.notificationCount += 1;
    },

    decrementNotification(state) {
      state.notificationCount -= 1;
    },

    resetNotification(state) {
      state.notificationCount = 0;
    },
  },
});

export const {
  setNotificationCount,
  incrementNotification,
  decrementNotification,
  resetNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;